import { DeepMutable, Properties } from "@util/types";
import Product, { Products, RootProductId } from "./Product";

export default class Category {
	constructor(
		props: Omit<DeepMutable<Properties<Category>>, "product">,
		productId: RootProductId
	) {
		this.id = props.id;
		this.name = props.name;
		this.longName = props.longName ?? props.name;
		this.isDeprecated = props.isDeprecated;
		this.maxAmountMonth = props.maxAmountMonth;
		this.extArticleId = props.extArticleId;
		this.groupId = props.groupId;
		this.#productId = productId;
	}

	readonly #productId: RootProductId;

	get product(): Product {
		return Products.getById(this.#productId);
	}

	static fromJson(data: any, productId: RootProductId) {
		return new Category(data, productId);
	}

	readonly id: string;
	readonly name: string;
	readonly longName: string;
	readonly isDeprecated: boolean;
	readonly maxAmountMonth?: number;
	readonly extArticleId?: string;
	readonly groupId?: string;
}
